<script>
import baseMixin from '@/mixins/baseMixin'
import timesheetMixin from '@/mixins/timesheetMixin'
import CandidateImage from '@/components/candidate/candidate-image.vue'
import { TimesheetOperationType } from '@/shared/constants/timesheet/TimesheetOperationType'
import {
  BookingStatus,
  hasCandidateModifiedBookingOrStatedDidNotHappen,
} from '@/shared/constants/booking/BookingStatus'
import TimesheetRecordsTable from './timesheet-records-table.vue'

export default {
  name: 'TimeSheetCandidateCard',
  components: {
    CandidateImage,
    TimesheetRecordsTable,
  },
  mixins: [baseMixin, timesheetMixin],
  props: {
    candidateTimeSheets: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      selectedTimesheets: [],
      TimesheetOperationType,
    }
  },
  computed: {
    compUnmodifiedBookings() {
      return this.candidateTimeSheets.filter(
        (timesheet) =>
          !hasCandidateModifiedBookingOrStatedDidNotHappen(
            timesheet.bookingStatus
          )
      )
    },
    hasUnmodifiedBookings() {
      return this.compUnmodifiedBookings.length > 0
    },
    compModifiedBookings() {
      return this.candidateTimeSheets.filter(
        (timesheet) =>
          timesheet.bookingStatus ===
          BookingStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED
      )
    },
    hasModifiedBookings() {
      return this.compModifiedBookings.length > 0
    },
    compDidNotHappenBookings() {
      return this.candidateTimeSheets.filter(
        (timesheet) =>
          timesheet.bookingStatus ===
          BookingStatus.CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN
      )
    },
    hasDidNotHappenBookings() {
      return this.compDidNotHappenBookings.length > 0
    },
  },
  methods: {
    changeTime(payload) {
      this.$emit('changeTime', payload)
    },
    cancelBookingSubmitted(payload) {
      this.$emit('cancelBookingSubmitted', payload)
    },
    emitSelectedTable(payload) {
      this.selectedTimesheets = payload?.timesheets ?? this.selectedTimesheets

      this.$emit('timesheetsUpdated', {
        key: payload?.key,
        timesheets: this.selectedTimesheets,
      })
    },
  },
}
</script>

<template>
  <v-card class="custom-elevation rounded-xl">
    <v-card-title class="d-flex align-center">
      <v-lazy>
        <CandidateImage
          :id="candidateTimeSheets[0].candidateId"
          :first-name="candidateTimeSheets[0].candidateFirstName"
          :last-name="candidateTimeSheets[0].candidateLastName"
          size="md"
        />
      </v-lazy>
      <p class="ml-3 my-0 subtitle-2">
        {{ candidateTimeSheets[0].candidateFullName }}
      </p>
    </v-card-title>

    <v-card-text v-if="hasUnmodifiedBookings">
      <p class="text-body-2 font-weight-medium mb-0">{{
        $t('timesheets.table.sections.unmodifiedTitle')
      }}</p>
    </v-card-text>
    <TimesheetRecordsTable
      v-if="hasUnmodifiedBookings"
      data-testid="timesheet-candidate-card-table-unmodified"
      :timesheets="compUnmodifiedBookings"
      @timesheetsUpdated="emitSelectedTable"
      @changeTime="changeTime"
      @cancelBookingSubmitted="cancelBookingSubmitted"
    />

    <v-card-text v-if="hasModifiedBookings">
      <p class="text-body-2 font-weight-medium mb-0">{{
        $t('timesheets.table.sections.modifiedTitle')
      }}</p>
    </v-card-text>
    <TimesheetRecordsTable
      v-if="hasModifiedBookings"
      data-testid="timesheet-candidate-card-table-modified"
      :timesheets="compModifiedBookings"
      @timesheetsUpdated="emitSelectedTable"
      @changeTime="changeTime"
      @cancelBookingSubmitted="cancelBookingSubmitted"
    />

    <v-card-text v-if="hasDidNotHappenBookings">
      <p class="text-body-2 font-weight-medium mb-0">{{
        $t('timesheets.table.sections.didNotHappenTitle')
      }}</p>
    </v-card-text>
    <TimesheetRecordsTable
      v-if="hasDidNotHappenBookings"
      data-testid="timesheet-candidate-card-table-didNotHappen"
      :timesheets="compDidNotHappenBookings"
      @timesheetsUpdated="emitSelectedTable"
      @changeTime="changeTime"
      @cancelBookingSubmitted="cancelBookingSubmitted"
    />
  </v-card>
</template>
